import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

import ConnectedCreatorStoreFront from 'components/CreatorStoreFront';

import CookieUtils from 'utils/Cookies';
import localeUtils from 'utils/LanguageLocale';
import urlUtils from 'utils/Url';

function CSFInitialize() {
    const currentCountryCode = CookieUtils.read('current_country');
    const isCountryUS = currentCountryCode === localeUtils.COUNTRIES.US;

    if (!isCountryUS) {
        urlUtils.redirectTo('/creators/error');

        return null;
    }

    return (
        <>
            <ConnectedCreatorStoreFront />
        </>
    );
}

export default wrapFunctionalComponent(CSFInitialize, 'CSFInitialize');
